import {I18n} from 'react-redux-i18n';

import {stringUtils} from 'front-onceforall-core';

export const renderPriceUnit = (price, currency, period = null, unit = null) => {
  let pricePerPeriod = I18n.t(`subscriptions.plans.pricePeriod.${period}`, {count: price});
  if (unit) {
    pricePerPeriod += I18n.t(`subscriptions.plans.unit.${unit}`);
  }

  return stringUtils.getCurrency(pricePerPeriod, I18n.t(`subscriptions.plans.currency.${currency}`));
};
